import Vue from 'vue'
import Router from 'vue-router'
import SelectFunctions from '@/select/SelectFunctions';


import { getConfig } from '@/select/Config';



Vue.use( Router );

function loadComponent ( view )
{
  return () => import(/* webpackChunkName: "component-[request]" */ `@/views/${ view }` );
}


const router =
  new Router( {
    mode: 'history',
    base: __dirname,
    routes: [
      {
        path: '/:id',
        name: 'CustomerPortal',
        component: loadComponent( 'CustomerPortal' ),
        meta: {
          isCustomerLink: true,
          title: 'Customer Portal'
        }
      },

      //Catch All Route (404)
      {
        path: '*',
        name: '404',
        component: loadComponent( 'PageNotFound' ),
        meta: {
          title: 'Page Not Found'
        }
      }
    ]
  } )
router.beforeEach( ( to, from, next ) =>
{
  getConfig().then( ( config ) =>
  {
    document.title = config.VUE_APP_APP_TITLE + ( to.meta.title ? ' | ' + to.meta.title : '' );
  } );
  
  next();
} );
export default router; 